import { useState } from "react";
import { Bell } from "lucide-react";
import { useReminders } from "../contexts/RemindersContext";
import { RemindersPageHeader } from "../components/RemindersPage/RemindersPageHeader";
import { RemindersList } from "../components/RemindersPage/RemindersList";
import { AddReminderModal } from "../components/modals/AddReminderModal";
import { EmptyComponentWithAnimation } from "../components/ShoppingListPage/EmptyComponentWithAnimation";
import { sortRemindersByUrgency } from "../utils/reminderUtils";

const phrases = ["That mayo isn't going to check on itself"];

export function RemindersPage() {
  const { reminders, addReminder, updateReminder, deleteReminder } = useReminders();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingReminder, setEditingReminder] = useState(null);

  const sortedReminders = sortRemindersByUrgency(reminders);

  const openAddModal = () => {
    setEditingReminder(null);
    setIsModalOpen(true);
  };

  const openEditModal = (reminder) => {
    setEditingReminder(reminder);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingReminder(null);
  };

  const handleSave = ({ reminderId, itemName, madeOrBoughtDate, durationDays }) => {
    if (reminderId) {
      updateReminder(reminderId, { itemName, madeOrBoughtDate, durationDays });
    } else {
      addReminder({ itemName, madeOrBoughtDate, durationDays });
    }
    closeModal();
  };

  return (
    <div className="h-full flex flex-col">
      <RemindersPageHeader onAddClick={openAddModal} />

      <div className="flex-1 overflow-auto p-4 md:p-8">
        {sortedReminders.length === 0 ? (
          <EmptyComponentWithAnimation
            icon={Bell}
            title="No reminders yet"
            description="Set a reminder for anything that might go bad before you get to it."
            phrases={phrases}
          />
        ) : (
          <RemindersList
            reminders={sortedReminders}
            onEdit={openEditModal}
            onDelete={deleteReminder}
          />
        )}
      </div>

      <AddReminderModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onSave={handleSave}
        editingReminder={editingReminder}
      />
    </div>
  );
}
